const scriptBlocks = /<\s*(script|iframe|object|embed|link|meta|base|form|input|style)[^>]*>.*?<\s*\/\s*\1\s*>/gis;
const unsafeTags = /<\s*(script|iframe|object|embed|link|meta|base|form|input)[^>]*\/?>/gis;
const eventAttributes = /\s+on[a-z0-9_-]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi;
const unsafeUrls = /(javascript:|data:text\/html|vbscript:)/gi;
const cssImport = /@import\s+[^;]+;/gis;
const cssUnsafe = /(expression\s*\(|javascript:|vbscript:|behavior\s*:|-moz-binding\s*:)/gi;
const cssGlobalEscape = /(^|})\s*(html|body|\*)\s*\{[^}]*}/gis;

export const sanitizeHtml = (html = '') => {
  return String(html)
    .replace(scriptBlocks, '')
    .replace(unsafeTags, '')
    .replace(eventAttributes, '')
    .replace(unsafeUrls, '');
};

export const sanitizeCss = (css = '') => {
  return String(css)
    .replace(cssImport, '')
    .replace(cssUnsafe, '')
    .replace(unsafeUrls, '')
    .replace(cssGlobalEscape, '');
};

export const sanitizeStyleValue = (value) => {
  if (typeof value !== 'string') return value;
  return value.replace(unsafeUrls, '').replace(/[{};]/g, '');
};
